module.exports = __webpack_public_path__ + "img/user.9644dc06.png";